import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import ProjetosApiService from "../../../../../services/api/ProjetosApiService";

const animatedComponents = makeAnimated();

/**
 * Opcoes de filtro por tipo de categoria
 *
 * @param {Object} clientes - Passar lista de clientes.
 * @param {Object} lideres - Passar lista de clientes.
 * @param {Object} projetos - Passar lista de projetos.
 * @param {string} radioFiltrarPor - Passar o tipo da categoria selecionada.
 * @returns Componente do listagem da categoria selecionada.
 */
export default function OpcoesFiltroPor(props) {
    const [categorias, setCategorias] = useState([]);
    const [categoriaSelect, setCategoriaSelect] = useState("");
    const [projetosFiltrados, setProjetosFiltrados] = useState(props.projetos);
    const [projetosFiltradosCliente, setProjetosFiltradosCliente] = useState(props.projetos);
    const [projetosFiltradosLider, setProjetosFiltradosLider] = useState(props.projetos);
    const [todosProjetosCategorias, setTodosProjetosCategorias] = useState(false);
    const [todasCategorias, setTodasCategorias] = useState(false);
    const [visualizarCategoria, setVisualizarCategoria] = useState(false);

    useEffect(() => {
        const feachData = async () => {
            const respCategorias = await ProjetosApiService.getCategories();
            setCategorias(respCategorias.data.data)
        }
        try {
            feachData();
        } catch (error) {
            console.error("Erro ao buscar categorias")
        }
    }, []);

    useEffect(() => {
        setProjetosFiltrados(props.projetos);
        setProjetosFiltradosLider(props.projetos);
        setProjetosFiltradosCliente(props.projetos);
        if (props.radioFiltrarPor === "projeto") {
            setVisualizarCategoria(true);
        } else {
            setVisualizarCategoria(false);
        }
    }, [props.radioFiltrarPor]);

    useEffect(() => {
        if (props.radioFiltrarPor !== "líder") {
            return;
        }

        setProjetosFiltradosLider(props.projetos);
        if (props.liderSelecionado && props.liderSelecionado !== '--Selecione o líder--') {
            setVisualizarCategoria(true);
            const projetosFiltradosLider = props.projetos.filter(item => item.lead === props.liderSelecionado)
            setProjetosFiltrados(projetosFiltradosLider);
            setProjetosFiltradosLider(projetosFiltradosLider);
        } else {
            setVisualizarCategoria(false);
        }
    }, [props.liderSelecionado, props.projetos, props.radioFiltrarPor]);

    useEffect(() => {
        if (props.radioFiltrarPor !== "cliente") {
            return;
        }

        setProjetosFiltradosCliente(props.projetos);
        if (props.clienteSelecionado && props.clienteSelecionado !== '--Selecione o cliente--') {
            setVisualizarCategoria(true);
            const projetosFiltradosCliente = props.projetos.filter(item => item.cliente != null && (item.cliente.clienteId == props.clienteSelecionado))
            setProjetosFiltrados(projetosFiltradosCliente);
            setProjetosFiltradosCliente(projetosFiltradosCliente);
        } else {
            setVisualizarCategoria(false);
        }
    }, [props.clienteSelecionado, props.projetos, props.radioFiltrarPor]);

    useEffect(() => {
        let projetosFiltro = [];

        if (props.radioFiltrarPor === "líder") {
            projetosFiltro = projetosFiltradosLider;
            const projetoFiltrado = categoriaSelect.length > 0 && projetosFiltro.filter(projeto =>
                categoriaSelect.some(category => category.value === projeto.category)
            );
            setProjetosFiltrados(projetoFiltrado);
        } else if (props.radioFiltrarPor === "cliente") {
            projetosFiltro = projetosFiltradosCliente;
            const projetoFiltrado = categoriaSelect.length > 0 && projetosFiltro.filter(projeto =>
                categoriaSelect.some(category => category.value === projeto.category)
            );
            setProjetosFiltrados(projetoFiltrado);
        } else {
            projetosFiltro = props.projetos;
            const projetoFiltrado = categoriaSelect.length > 0 && projetosFiltro.filter(projeto =>
                categoriaSelect.some(category => category.value === projeto.category)
            );
            setProjetosFiltrados(projetoFiltrado);
        }

        if (categoriaSelect.length === 0) {
            setProjetosFiltrados(projetosFiltro);
        }

        if (todasCategorias) {
            setTodosProjetosCategorias(false)
            props.setProjetosSelecionados([])
        }
    }, [categoriaSelect]);

    const handleClienteChange = (event) => {
        props.setProjetosSelecionados("");
        const selectedIndex = event.target.selectedIndex;
        const selectedOptionText = event.target.options[selectedIndex].text;
        const selectedValue = event.target.value;
        if (selectedValue === '--Selecione o cliente--') {
            props.setClienteSelecionado('');
            props.setClienteLabel("Cliente não cadastrado");
        } else {
            props.setClienteSelecionado(selectedValue);
            props.setClienteLabel(selectedOptionText);
        }
    };

    const handleLideresChange = (e) => {
        props.setProjetosSelecionados("")
        const selectedValue = e.target.value;
        if (selectedValue === '--Selecione o cliente--') {
            props.setLiderSelecionado('');
        } else {
            props.setLiderSelecionado(selectedValue);
        }
    }

    const handleCategoriaChange = (selectedOption) => {
        setCategoriaSelect(selectedOption);
    };

    const handleProjetosChange = (selectedOptions) => {
        const todosOptionSelected = selectedOptions.some(option => option.value === 'TODOS');

        if (todosOptionSelected) {
            setTodosProjetosCategorias(true);
            setTodasCategorias(true);
            const todosMenosTodos = optionsProjetosTodos.filter(option => option.value !== 'TODOS');
            props.setProjetosSelecionados(todosMenosTodos);
        } else {
            setTodosProjetosCategorias(false);
            setTodasCategorias(false);
            props.setProjetosSelecionados(selectedOptions);
        }
    };

    const optionsProjetos = [
        ...projetosFiltrados
            .slice()
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(item => ({
                id: item.id,
                value: item.key,
                label: `${item.key} - ${item.name} - ${item.category}`,
                categoria: item.category
            }))
    ];

    const optionsProjetosTodos = [
        { value: "TODOS", label: 'TODOS OS PROJETOS' },
        ...projetosFiltrados
            .slice()
            .sort((a, b) => a.key.localeCompare(b.key))
            .map(item => ({
                id: item.id,
                value: item.key,
                label: `${item.key} - ${item.name} - ${item.category}`,
                categoria: item.category
            }))
    ];

    return (
        <>
            {props.radioFiltrarPor === "default" && (<></>)}

            {props.radioFiltrarPor !== "default" && (
                <>
                    {props.radioFiltrarPor === "cliente" && (
                        //Select do cliente
                        <Form.Group>
                            <Form.Label>Selecione o cliente: *</Form.Label>
                            <Form.Control
                                as="select"
                                name="clientes"
                                onChange={handleClienteChange}
                            >
                                <option>--Selecione o cliente--</option>
                                {props.clientes
                                    .slice()
                                    .sort((a, b) => a.nome.localeCompare(b.nome))
                                    .map((item, index) => (
                                        <option value={item.id} key={index}>{item.nome}</option>
                                    ))
                                }
                            </Form.Control>
                        </Form.Group>
                    )}

                    {props.radioFiltrarPor === "líder" && (
                        //Select do líder
                        <Form.Group>
                            <Form.Label>Selecione o líder: *</Form.Label>
                            <Form.Control
                                as="select"
                                name="lider"
                                onChange={handleLideresChange}
                            >
                                <option value={""}>--Selecione o líder--</option>
                                {props.lideres
                                    .slice()
                                    .sort((a, b) => a.lead.localeCompare(b.lead))
                                    .map((item, index) => (
                                        <option value={item.lead} key={index}>{item.lead}</option>
                                    ))
                                }
                            </Form.Control>
                        </Form.Group>
                    )}

                    {(visualizarCategoria) && (
                        <>
                            <Form.Group>
                                <Form.Label>Selecione as categorias:</Form.Label>
                                <Select
                                    components={animatedComponents}
                                    isMulti
                                    options={categorias.map(categoria => ({
                                        value: categoria.name,
                                        label: categoria.name,
                                        id: categoria.id,
                                    }))}
                                    value={categoriaSelect}
                                    onChange={(e) => { handleCategoriaChange(e) }}
                                    placeholder="Selecione uma categoria"
                                    closeMenuOnSelect={true}
                                />
                            </Form.Group>
                            {props.habilitarMultiSelect ? (
                                <Form.Group>
                                    <Form.Label>Selecione os projetos: *</Form.Label>
                                    <Select
                                        components={animatedComponents}
                                        isMulti
                                        options={optionsProjetosTodos}
                                        value={props.projetosSelecionados}
                                        onChange={(e) => { handleProjetosChange(e) }}
                                        placeholder="Selecione os projetos"
                                        closeMenuOnSelect={true}
                                    />
                                </Form.Group>
                            ) : (
                                <Form.Group>
                                    <Form.Label>Selecione o projeto: *</Form.Label>
                                    <Select
                                        components={animatedComponents}
                                        isMulti={false}
                                        options={optionsProjetos}
                                        value={props.projetosSelecionados}
                                        onChange={(e) => { props.setProjetosSelecionados(e) }}
                                        placeholder="Selecione o projeto"
                                        closeMenuOnSelect={true}
                                    />
                                </Form.Group>
                            )}
                        </>
                    )}
                </>
            )}
        </>
    );
}